import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const firestore = firebase.firestore();
const storage = firebase.storage();

export { firestore, auth, storage };

export const GoogleProvider = new firebase.auth.GoogleAuthProvider();
GoogleProvider.setCustomParameters({ prompt: "select_account" });

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      unsubscribe();
      resolve(userAuth);
    }, reject);
  });
};

// DB PERSISTENCE
const firestoreSettings = {
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED,
  synchronizeTabs: true,
};
firestore.settings({
  ...firestoreSettings,
  merge: true,
});
try {
  firestore.FirestoreSettings.cache(firestoreSettings);
} catch (err) {
  if (err.code === "failed-precondition") {
    // console.log("Multiple tabs open")
  } else if (err.code === "unimplemented") {
    // console.log("Does not support persistence")
  }
}

//CREATE USER PROFILE
export const handleUserProfile = async ({ userAuth }) => {
  if (!userAuth) return;
  const { uid } = userAuth;
  const userRef = firestore.doc(`users/${uid}`);
  const snapshot = await userRef.get();

  if (!snapshot.exists) {
    //PESONAL DETAILS
    const { displayName, email, photoURL } = userAuth;

    //STATUS
    const isOnline = false;
    //USER ROLES
    const userRoles = ["user"];
    //CREATED DATE
    const timestamp = new Date();
    try {
      await userRef.set({
        displayName,
        email,
        photoURL,
        isOnline,
        userRoles,
        createdDate: timestamp,
      });
    } catch (err) {
      console.log(err);
    }
  }

  return userRef;
};
